<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { loadSiteConfig } from '@/composables/useSiteConfig.js';

onMounted(() => {
  loadSiteConfig();
});
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  width: 100%;
  height: 100vh;
  background-color: #f5f7fa;
}
#app {
  width: 100%;
  height: 100%;
  margin: 0 ;
  background-color: rgba(220,220,220,0.1);
}

::-webkit-scrollbar {
  display: none;
}

@media screen and (max-width: 1240px) {
  #app {
    width: 100%; /* 在小屏幕上设置宽度为100% */
    Overflow:hidden;
    margin: 0;
  }
}
@media (max-width: 768px) {
  #app {
    width: 100%; /* 在小屏幕上设置宽度为100% */
    Overflow:hidden;
    margin: 0;
  }
}

@media (max-width: 480px) {
  #app {
    width: 100%; /* 在小屏幕上设置宽度为100% */
    Overflow:hidden;
    margin: 0;
  }
}
</style>
